import {initTextEditor} from "../../../utils/editor";

function initFormFieldRichText() {
  $('.form-field-rich-text').each(function () {
    let textElementId = $(this).attr('id');
    let containerId = $(this).prev('div').attr('id');

    initTextEditor(containerId, textElementId);
  });
}

$(function () {
  initFormFieldRichText();
});

